import {Button, Form, Input, Modal, ModalProps, Select, Space} from "antd";
import * as React from "react";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/financeWriteOff"
import dayjs from "dayjs";
import {useEffect, useState} from "react";
import CategoryCascader from "../../../../components/CategoryCascader";
import {useRequest} from "ahooks";
import * as categoryApi from "../../../../apis/productCategory";
import DictSelect from "../../../../components/DictSelect";

interface OrderSelectModalProps extends ModalProps {
    dealerId?: number,
    columns?: StandardColumnsType,
    onComplete?: (keys?: number[], records?: any[]) => void,
}

function OrderSelectModal(props: OrderSelectModalProps) {
    const {dealerId, onCancel, onOk, onComplete, columns = [], ...otherProps} = props;
    const [categories, setCategories] = useState([]);
    const {
        tableProps,
        form,
        search,
        refresh
    } = useAntTable(`${api.getWriteOffOrders}?dealerId=${dealerId}`, {selectTable: 'multiple', manual: false});

    useEffect(() => {
        refresh()
    }, [props.open])

    const {loading: loadingProductCategory} = useRequest(categoryApi.getCategoriesDict, {
        onSuccess(res) {
            setCategories(res.data.data);
        }
    });

    const tableColumns = columns.length ? columns : [
        {
            dataIndex: 'orderCode',
            title: '订单号'
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'categoryName',
            title: '产品线'
        },
        {
            dataIndex: 'hospitalFullName',
            title: '终端医院',
        },
        {
            dataIndex: 'orderAmount',
            title: '订单金额'
        },
        {
            dataIndex: 'unpaidAmount',
            title: '未付款金额'
        },
        {
            dataIndex: 'dateOfReceivable',
            title: '应收款日期',
            render: (value: any) => value && dayjs(value).format('ll')
        },
        {
            dataIndex: 'invoices',
            title: '发票号'
        }
    ];

    const handleOk = (e: React.MouseEvent<HTMLButtonElement>) => {
        onOk && onOk(e)
        onComplete && onComplete(tableProps?.rowSelection?.selectedRowKeys, tableProps?.rowSelection?.selectedRows);
    }
    const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
        onCancel && onCancel(e);
    }

    const toolbar =
        <Space style={{flex: 1}}>
            <Form form={form}>
                <Space>
                    <Form.Item name={'code'} style={{marginBottom: 0}}>
                        <Input placeholder={'请输入订单编号'} allowClear/>
                    </Form.Item>
                    <Form.Item name={'category'} style={{marginBottom: 0}}>
                        <CategoryCascader style={{width: 150}} placeholder={'请选择产品线'} options={categories}
                                          changeOnSelect
                                          fieldNames={{label: "name", children: "children", value: "id"}}/>
                    </Form.Item>
                    <Form.Item name={'paymentForm'} style={{marginBottom: 0}}>
                        <DictSelect style={{width: 150}}  placeholder={'请选择付款形式'} dict={'PaymentForm'} defaultValue={null}/>
                    </Form.Item>
                    <Button onClick={search.reset}>重置</Button>
                    <Button type={"primary"} onClick={search.submit} loading={tableProps.loading}>搜索</Button>
                </Space>
            </Form>
        </Space>

    return <Modal {...otherProps} width={1000} onOk={handleOk} onCancel={handleCancel} destroyOnClose>
        <StandardTable {...tableProps} rowKey={'orderCode'} submit={search.submit} form={form}
                       columns={tableColumns} search={search}
                       toolbar={toolbar}
                       showCard={false}
        />
    </Modal>
}

export default OrderSelectModal;